import { gql } from '@apollo/client';

export const CORE_TOOL_CATEGORY_FIELDS = gql`
  fragment CoreToolCategoryFields on ToolCategory {
    id
    name
    toolHoundId
    toolTypeId
  }
`;

export const GET_TOOL_CATEGORIES = gql`
  query ToolCategoryGroupByName {
    toolCategoryGroupByName {
      id
      name
      toolCategoryStats {
        consumablesCount
        toolsCount
      }
    }
  }
`;

export const SEARCH_TOOL_CATEGORY = gql`
  query SearchToolCategories($searchInput: SearchInput) {
    searchToolCategories(searchInput: $searchInput) {
      items {
        id
        name
        isActive
        toolType {
          id
          name
        }
        toolHoundId
        createdBy
        toolCategoryStats {
          consumablesCount
          equipmentCount
          toolsCount
        }
      }
    }
  }
`;
